var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-fields-edit",
    {
      attrs: {
        title: _vm.$ct("edit-free-block-i", { number: _vm.index + 1 }),
        line: _vm.value.Lines,
      },
    },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("w-input", {
                attrs: {
                  value: _vm.name,
                  label: _vm.$ct("common.name"),
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.onNameInput($event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "6" } },
            [
              _c("app-select-placement", {
                attrs: {
                  layout: _vm.layout,
                  "full-control": true,
                  value: _vm.value.Placement,
                  fancy: "",
                  label: _vm.$ct("placement"),
                },
                on: {
                  input: function ($event) {
                    return _vm.setPlacement($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }